import React from "react";
import { useLocation } from "react-router";
import { Link } from "react-router-dom";

interface IProps {
  link: string;
  title: string;
  onClick?: () => void;
}

const NaviLink: React.FC<IProps> = ({ link, title, onClick }) => {
  const location = useLocation();

  const isActiveRoute = (): boolean => {
    return location.pathname === link;
  };
  return (
    <Link onClick={onClick} className={isActiveRoute() ? "navi-link active" : "navi-link"} to={link}>
      {title}
    </Link>
  );
};

export default NaviLink;
